<div class="container">

   <app-page-title title="Technical Support"
                   icon="fa-headset"
                   eyebrow="Help"
                   subtitle="Phone, email and hours for Southwestern Advantage dealer support" />

   <section class="d-flex flex-column justify-content-center mt-2">

      <div class="alert alert-light mt-3" role="alert">
         <div class="fs-3 site-text-primary fw-bold">Southwestern Advantage Dealer Support</div>

         <ul>
            <li>
               <span class="fw-bold">Phone:</span> +1 866.322.7093
            </li>
            <li>
               <span class="fw-bold pe-1">Email:</span> <a href="mailto:swdealers@southwestern.com">swdealers&#64;southwestern.com</a>
            </li>
            <li>
               <span class="fw-bold">Hours:</span> 8:00am - 6pm CST Monday - Friday
            </li>
         </ul>

         <p>
            This support line is for technical issues encountered by dealers regarding the
            use of our business Apps or the support portal (advantage4dealers.com).<br/><br/>
            <span class="fw-bold">Please direct any customer-related questions to the regular customer support line.</span>
         </p>

      </div>

   </section>

</div>
